import React from 'react';
import { PropTypes } from 'prop-types';

const RadioField = ({ field: { name, onChange, onBlur }, id, styles, labelMessage, checked, eventId }) => {
    return (
        <label data-event-id={eventId} htmlFor={id} className={styles.label}>
            <input
                name={name}
                id={id}
                value={id}
                checked={checked}
                className={styles.input}
                onChange={onChange}
                onBlur={onBlur}
                type="radio"
            />
            <span className={styles.radio}>{checked && <span className={styles.radioChecked} />}</span>
            <span className={styles.labelMessage}>{labelMessage}</span>
        </label>
    );
};

RadioField.propTypes = {
    styles: PropTypes.shape().isRequired,
    field: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        name: PropTypes.string.isRequired,
    }).isRequired,
    // eslint-disable-next-line
    id: PropTypes.string,
    labelMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    checked: PropTypes.bool,
};

RadioField.defaultProps = {
    checked: false,
};

export default RadioField;
